import { useQuery } from "@tanstack/react-query";
import type { ChemistryResult } from "../../../../models/lab.models";
import { getChemistryByHeat } from "../../repositories/ChemistriesRepository";

interface UseChemistriesQueryProps {
  assetId: number | null;
  heatId: number | null;
  refetchInterval?: number | false;
}

export const useChemistriesQuery = ({
  assetId,
  heatId,
  refetchInterval = false,
  onError,
}: UseChemistriesQueryProps & { onError?: (error: Error) => void }) => {
  return useQuery<ChemistryResult[], Error>({
    queryKey: ["lab-chemistries", heatId],
    meta: { realtime: ["RBD.GetChemistriesByHeatId"] },
    queryFn: async ({ signal }) => {
      const resp = await getChemistryByHeat({
        assetId,
        heatId: heatId!,
        signal,
      });
      return resp.data.tables[0].rows;
    },
    enabled: !!heatId,
    refetchInterval,
    onError,
  });
};
